import(/* webpackMode: "eager" */ "/app/src/app/techstack/detail/[id]/page.client.tsx");
import(/* webpackMode: "eager" */ "/app/src/utils/utils.ts")